import apiClient, { safeJson } from '@/api/client';
import {
    CenterReviewDashboardResponse,
    CoachReviewDashboardResponse,
    MemberReviewDetailResponse,
    MemberReviewDashboardResponse,
} from './types';

/**
 * @method get
 * @brief 관리자 센터 리뷰 통계 대시보드
 */
export const getCenterReviewDashboard = async ({ centerId }: { centerId: string }) => {
    const res = await apiClient.get(`v1/centers/center-review-dashboard/${centerId}`);

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as CenterReviewDashboardResponse | null,
    };
};

/**
 * @method get
 * @brief 관리자 강사 리뷰 통계 대시보드
 */
export const getCoachReviewDashboard = async ({ coachId, centerId }: { coachId: string; centerId?: string }) => {
    const search = centerId ? `?centerId=${encodeURIComponent(centerId)}` : '';
    const res = await apiClient.get(`v1/centers/coach-review-dashboard/${coachId}${search}`);

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as CoachReviewDashboardResponse | null,
    };
};

/**
 * @method get
 * @brief 관리자 회원 리뷰 상세 조회
 */
export const getMemberReviewDetail = async ({ reviewId }: { reviewId: string }) => {
    const res = await apiClient.get(`v1/centers/member-review-detail/${reviewId}`);

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as MemberReviewDetailResponse | null,
    };
};

/**
 * @method get
 * @brief 관리자 회원 리뷰 리스트 조회
 */
export const getMemberReviewList = async ({ centerId }: { centerId: string }) => {
    const res = await apiClient.get(`v1/centers/member-review-list/${centerId}`);

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as MemberReviewDashboardResponse | null,
    };
};
